import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';

export const TitleContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.medium};

  span.material-section-title-disabled {
    color: ${theme.color.designSystem.blackOpacity87};
  }
`;

export const AlertStyledContainer = styled('div')`
  background-color: #e5f6fd;
  border-radius: 8px;
  padding: 12.5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: start;
`;

export const AlertTitleContainer = styled('div')`
  display: flex;
  gap: 1rem;
`;

export const AlertTextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small};
`;

export const AlertTitle = styled('p')`
  color: #014361;
  font-family: Work Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const AlertSubTitle = styled('p')`
  color: #014361;
  font-family: Work Sans;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const ExitPreviewButton = styled('button')`
  background-color: transparent;
  border: none;
  border-radius: 4px;
  color: #014361;
  cursor: pointer;
  font-family: Work Sans;
  font-size: 14px;
  padding: 6px;

  &:hover {
    background-color: ${theme.color.blackAlpha(0.04)};
  }
`;
